<div class="popupClose">
    <img src="/icons/close-kb.svg" mat-dialog-close width="20px" alt="Close terms of use Popup">
</div>
<mat-dialog-content>
    <cx-page-slot position="TermsofUseLink"></cx-page-slot>
    <!-- kindly rteplace the position of the slot with correct name -->
</mat-dialog-content>